export const API_KEY = window.competition_setup.api_key;
export const BASE_URL = window.competition_setup.api_url;
export const COMPETITION_ID = window.competition_setup.competition_id;
export const API_REGISTER = `${BASE_URL}user?withs[]=profiles&withs[]=token`;
export const API_AUTH_LOGIN = `${BASE_URL}auth/login`;
export const AUTH_REFRSH = `${BASE_URL}auth/refresh?api=${API_KEY}`;
export const API_LOGIN = (id) => `${BASE_URL}user/${id}`;
export const GET_COUNTRIES = `${BASE_URL}term?api=${API_KEY}&taxonomy[quick]=country`;
export const GET_NATIONALITIES = `${BASE_URL}term?api=${API_KEY}&taxonomy[quick]=nationality`;
export const GET_COMPETITION = `${BASE_URL}competition/${COMPETITION_ID}?api=${API_KEY}&withs=genres.categories${window.competition_setup.hasOwnProperty('lang') ? '&lang=' + window.competition_setup.lang : ''}`;
export const POST_ENTRY = `${BASE_URL}entry`;
export const POST_ENTRY_IMAGE = `${BASE_URL}image`;
export const GET_ENTRIES = (profileId) => `${BASE_URL}entry?api=${API_KEY}&profile_id=${profileId}&withs=category&withs=category.genre.competition&id[order]=desc`;
export const GET_ENTRY_IMAGE = (profileId) => `${BASE_URL}entry?api=${API_KEY}&profile_id=${profileId}&withs=images`;
export const DELETE_ENTRY = (entryId) => `${BASE_URL}entry/${entryId}?api=${API_KEY}`;
export const FINALISE_ENTRY = (entryId) => `${BASE_URL}entry/${entryId}?api=${API_KEY}`;
export const UPDATE_USER = (userId) => `${BASE_URL}user/${userId}?api=${API_KEY}`;
export const UPDATE_PROFILE = (profileId) => `${BASE_URL}profile/${profileId}?api=${API_KEY}`;
export const API_LOGOUT = `${BASE_URL}auth/logout?api=${API_KEY}`;
export const GET_INSTITUTIONS = `${BASE_URL}institution/quick-list?api=${API_KEY}`;

//screens
export const TAB_CATEGORIES = 'TAB_CATEGORIES';
export const TAB_ENTRY_UPLOAD = 'TAB_ENTRY_UPLOAD';
export const TAB_ENTRY_SUBMITTED = 'TAB_ENTRY_SUBMITTED';
export const SCR_OVERVIEW = 'SCR_OVERVIEW';
export const SCR_PROFILE = 'SCR_PROFILE';
export const SCR_COMPETITION = 'SCR_COMPETITION';
export const SCR_PROFILE_UPDATED = 'SCR_PROFILE_UPDATED';
export const SCR_VIEW_ENTRY = 'SCR_VIEW_ENTRY';

export const LABEL_MISSING = '[LABEL NOT FOUND]';

export const RECAPTCHA_TOKEN_FIELD = 'recaptchaToken';
export const RECAPTCHA_SITE_KEY = '6Lc4MEErAAAAABJF9_zdurZU2ptXxx443E9XadCy';